/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from '@fluentui/react-components';
import {
  MessageBar,
  MessageBarActions,
  MessageBarTitle,
  MessageBarBody,
} from '@fluentui/react-message-bar';
import {
  DismissRegular,
} from '@fluentui/react-icons';
import {
  PERFORMANCE_INSIGHTS_ISSUE,
  PERFORMANCE_INSIGHTS_TYPE,
  PERFORMANCE_INSIGHTS_POPUP_CONFIG,
} from './constants/consts';

export const Notification = (props) => {
  const {
    isSuccess,
    isError,
    newI18n,
    allData,
    entity,
    setIsSuccess,
    setIsError,
    onClickRetry,
    classes,
  } = props;

  return (
    <>
      {isSuccess &&
        <MessageBar
          key="success"
          layout="singleline"
          intent="success"
          className={classes.messageBar}
        >
          <MessageBarBody className={classes.messageBarBody}>
            <MessageBarTitle className={classes.messageBarTitle}>{newI18n.getString(_TL_('Success'))}</MessageBarTitle>
            {newI18n.getString(_TL_(PERFORMANCE_INSIGHTS_POPUP_CONFIG[PERFORMANCE_INSIGHTS_TYPE.ISSUE][PERFORMANCE_INSIGHTS_ISSUE.BUDGET].successMessage), { campaignName: entity.Name, recommendedBudget: allData[PERFORMANCE_INSIGHTS_ISSUE.BUDGET].recommendedBudget })}
          </MessageBarBody>
          <MessageBarActions
            containerAction={
              <Button
                aria-label="dismiss"
                appearance="transparent"
                icon={<DismissRegular />}
                onClick={() => setIsSuccess(false)}
              />
            }
          />
        </MessageBar>
      }
      {isError &&
        <MessageBar
          key="error"
          layout="singleline"
          intent="error"
          className={classes.messageBar}
        >
          <MessageBarBody className={classes.messageBarBody}>
            <MessageBarTitle className={classes.messageBarTitle}>{newI18n.getString(_TL_('Failed'))}</MessageBarTitle>
            {newI18n.getString(_TL_(PERFORMANCE_INSIGHTS_POPUP_CONFIG[PERFORMANCE_INSIGHTS_TYPE.ISSUE][PERFORMANCE_INSIGHTS_ISSUE.BID].failMessage), { campaignName: entity.Name, latestSuggestTarget: allData[PERFORMANCE_INSIGHTS_ISSUE.BID].latestSuggestTarget })}
          </MessageBarBody>
          <MessageBarActions
            containerAction={
              <Button
                aria-label="dismiss"
                appearance="transparent"
                icon={<DismissRegular />}
                onClick={() => setIsError(false)}
              />
            }
          >
            <Button onClick={() => onClickRetry()}>{newI18n.getString(_TL_('Retry'))}</Button>
          </MessageBarActions>
        </MessageBar>
      }
    </>
  );
};

Notification.propTypes = {
  isSuccess: PropTypes.bool.isRequired,
  isError: PropTypes.bool.isRequired,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  allData: PropTypes.shape({}).isRequired,
  entity: PropTypes.shape({
    Name: PropTypes.string,
    Id: PropTypes.number,
  }).isRequired,
  setIsSuccess: PropTypes.func.isRequired,
  setIsError: PropTypes.func.isRequired,
  onClickRetry: PropTypes.func.isRequired,
  classes: PropTypes.shape({}).isRequired,
};
